import Box from "@mui/material/Box";
import { ErrorBoundary } from "react-error-boundary";
import { Route, Routes } from "react-router";
import AddClientForm from "./add-client";
import ErrorFallback from "../common/ErrorFallback";
import ClientListContainer from "./client-list";
import ClientDetailsWrapper from "./client-details";

function ClientContainer() {
  return (
    <Box
      data-testid="client-container"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Routes>
          <Route path="/" element={<ClientListContainer />} />
          <Route path="/view/:id" element={<ClientDetailsWrapper />} />
          <Route path="/new" element={<AddClientForm />} />
        </Routes>
      </ErrorBoundary>
    </Box>
  );
}

export default ClientContainer;
